import { nanoid } from 'nanoid/async'
import { facebookMediaModal } from './facebookMediaModal'
import { updateNodeConnections } from '../../utils/functions'

// eslint-disable-next-line no-unused-vars
export default async (node, editor) => {
  const inputValue = node.data
  const { value: facebookMediaData } = await facebookMediaModal(inputValue, node)

  if (facebookMediaData) {
    // Create text unique ID if there is not any
    if (! ('uniqueId' in node.data)) {
      node.data.uniqueId = await nanoid(15)
    }
    
    Object.assign(node.data, facebookMediaData)
    node.update()
    updateNodeConnections(node)
  }


  return false
}